import { DashboardView } from "modules/street-statistics";
import { Wrapper } from "components/layout";

export function StreetStatisticsPage() {
  return (
    <Wrapper title="Street statistic Page">
      <div className="flex p-5 mx-auto w-[98%] bg-white shadow-xs rounded-lg">
        <DashboardView />
      </div>
    </Wrapper>
  );
}
